import type { ReactNode } from 'react';
import { Navigate } from 'react-router';

import { paths } from '@/app/routes/paths';
import { isEmailVerified, useAuthStore } from '@/store';

export function RequireVerified({ children }: { children: ReactNode }) {
  const user = useAuthStore((s) => s.user);

  if (!isEmailVerified(user)) {
    return <Navigate to={paths.dashboard} replace />;
  }
  return children;
}
